import React from 'react';
import styled from 'styled-components/macro';

import useMousePosition from '../../hooks/useMousePosition';

const MouseCursor = styled.div<{ cursor: 'none' | 'hover' | 'pointer' }>`
  position: fixed;
  top: 0;
  left: 0;
  transition: transform 0.3s ease-in-out;
  transform: translate(-50%, -50%) ${({ cursor }) => (cursor === 'pointer' ? 'scale(1.5)' : 'scale(1)')};
  background-color: #dfdfdf;
  width: 20px;
  height: 20px;
  border-radius: 100%;
  z-index: 999;
  pointer-events: none;
  mix-blend-mode: overlay;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    display: none;
  `}
`;

const ScreenCursor: React.FC<{ mouseState: 'none' | 'hover' | 'pointer' }> = ({ mouseState }) => {
  const { x, y } = useMousePosition();

  if (mouseState === 'none') return <></>;

  return (
    <>
      <MouseCursor style={{ left: `${x}px`, top: `${y}px` }} cursor={mouseState} />
    </>
  );
};

export default ScreenCursor;
